import React, {useState} from 'react'
import {useSelector} from "react-redux";
import Popup from "../../Popup";
import Button from "../../../UI/Button";
import useGetJobs from "../../../Global/Api/Jobs/getJobs.api";
import './index.scss'

export default function JobCancel() {
  const Jobs = useGetJobs();
  const [showCanceledModal, setShowCanceledModal] = useState(false)
  const { activeJob } = useSelector((state) => state.rootReducer.jobsSlice);

  const closeCanceledModal = () => {
    setShowCanceledModal(false)
  }

  const cancelJob = async () => {
    await Jobs.cancel(activeJob?.id);
    setShowCanceledModal(false)
  }
  return (
    <>
    {
      activeJob?.can_cancel && (
      <div className='jobCancel'>
        {showCanceledModal && (
          <Popup
            title='Confirm your action'
            closePopup={closeCanceledModal}
          >
            <div className="technician__popup">
              <p className="technician__popup-text">
                Canceling this job inside of the 24 hour period will result in full payment of this scheduled appointment.
              </p>
              <div className="technician__popup-btns">
                <div className="technician__popup-btn technician__popup-btn_cancel">
                  <Button
                    text='Keep Appointment'
                    onClick={closeCanceledModal}
                  />
                </div>
                <div className="technician__popup-btn technician__popup-btn_red">
                  <Button
                    onClick={cancelJob}
                    text='Confirm Cancel'
                  />
                </div>
              </div>
            </div>
          </Popup>
        )}
        <div className="jobCancel__left">
        </div>
        <div className="jobCancel__right">
          <div onClick={() => {setShowCanceledModal(true)}} className="jobCancel__btn jobCancel__btn_cancel">Cancel job</div>
        </div>
      </div>
      )
    }
    </>
  )
}
